// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation();
jQuery(document).ready(function($) {

  if( $('.splash').length > 0 ) {
    $('.splash').delay(2000).fadeOut(1500);
    setTimeout(function() {
      $('.off-canvas-content').attr('style', 'opacity: 1 !important');
    }, 2000);
  }


  $('.top-bar').css('opacity', '1');

if( $('section.services').length > 0 ) {

  $('.service-wrapper').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    prevArrow: $('.arrows button.prev'),
    nextArrow: $('.arrows button.next'),
    speed: 1100,
  });

}

if( $('section.service').length > 0 ) {

  $('.service-title-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.service-image-slider, .service-content-slider',
    vertical: true,
    focusOnSelect: true,
  });

  $('.service-content-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.service-image-slider, .service-title-slider',
    fade: true,
    // adaptiveHeight: true,
  });

  $('.service-image-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.service-title-slider, .service-content-slider',
    focusOnSelect: true,
    prevArrow: $('.arrows button.prev-servicesingle'),
    nextArrow: $('.arrows button.next-servicesingle'),
  });

  // $('.arrows button.next-servicesingle').click(function() {
  //  $('.service-content-slider').slick('slickGoTo', parseInt($('.service-content-slider').slick('slickCurrentSlide'))+1);
  // });
  //
  // $('.arrows button.prev-servicesingle').click(function() {
  //  $('.service-content-slider').slick('slickGoTo', parseInt($('.service-content-slider').slick('slickCurrentSlide'))-1);
  // });

}

if( $('section.work').length > 0 ) {

  $('.work-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    prevArrow: $('button.prev-work'),
    nextArrow: $('button.next-work'),
    speed: 1000,
    responsive: [
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 880,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },
    ]
  });

}

if( $('.gform_wrapper').length > 0 ) {
  $('.gfield .ginput_container input').focus(function() {
    console.log('click');
    $(this).parent().parent().addClass('focused');
  })
  $('.gfield .ginput_container textarea').focus(function() {
    $(this).parent().parent().addClass('focused');
  })
}

if( $('section.mission' ).length > 0 ) {
  $('.mission-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.arrows button.prev-mission'),
    nextArrow: $('.arrows button.next-mission'),
    speed: 1200,
  });
}

if( $('section.servicebanner').length > 0 ) {
  $('.banner-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('button.prev'),
    nextArrow: $('button.next'),
    speed: 1000,
    responsive: [
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
      {
          breakpoint: 880,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },
    ]
  });
}

if( $('section.process-intro' ).length > 0 ) {

  $('.process-nav').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    centerMode: true,
    focusOnSelect: true,
    asNavFor: '.process-slider',
    responsive: [
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
          }
      },
    ]
  });

  $('.process-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.arrows button.prev-process'),
    nextArrow: $('.arrows button.next-process'),
    asNavFor: '.process-nav',
    speed: 1000,
  });

  $(".nav-title").click(function() {
    document.getElementById("process-content").scrollIntoView( {behavior: "smooth" });
  });

  //Implementing navigation of slides using mouse scroll
  $('.process-nav').on('wheel', (function(e) {
    e.preventDefault();
    if (e.originalEvent.deltaY < 0) {
      $(this).slick('slickNext');
    } else {
      $(this).slick('slickPrev');
    }
  }));

  var $status = $('.step-counter');
  var $slickElement = $('.process-nav');

  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.html( '<span class="current_slide">' + i + '</span> ');
  });

}

  // hide/show nav on scroll
  var prev = 0;
  var $window = $(window);
  var nav = $('.header');

  $window.on('scroll', function(){
    var scrollTop = $window.scrollTop();
    nav.toggleClass('hidden', scrollTop > prev);
    prev = scrollTop;
  });


  // Hotspot Listener
//   $('.hotspot .icon').on('click', function() {
//     var $parent = $(this).parent();
//     $parent.toggleClass('open');
//     $('.hotspot.open').not($parent).removeClass('open');
//
//   });
//
//   $('.hotspot').each(function(e, i) {
//     var $this = $(this);
//     var css = detectPosition($this, e);
//     $(this).addClass(css.css).attr('style', css.styles)
//   });




//   let parent = document.querySelector('.folderflip_tag').parentElement;
//
//   while (parent) {
//       const hasOverflow = getComputedStyle(parent).overflow;
//       if (hasOverflow !== 'visible') {
//           console.log(hasOverflow, parent);
//       }
//       parent = parent.parentElement;
//   }

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
        $(this).wrap("<div class='widescreen flex-video'/>");
    } else {
        $(this).wrap("<div class='flex-video'/>");
    }
  });

  //Smooth Scroll
  $('a[href*="#"]:not([role="tab"]):not(.skip-anchor)').on("click", function() {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 125
          },
          1000
        );
        return false;
      }
    }
  });
  //Smooth Scroll on page load if hash
  var hash = window.location.hash;
  if (hash) {
    var target = $(hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 125
        },
        1000
      );
      return false;
    }
  }

  //VIDEO LazyLoad
//   var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
//
//   if ("IntersectionObserver" in window) {
//     var lazyVideoObserver = new IntersectionObserver(function(
//       entries,
//       observer
//     ) {
//       entries.forEach(function(video) {
//         if (video.isIntersecting) {
//           for (var source in video.target.children) {
//             var videoSource = video.target.children[source];
//             if (
//               typeof videoSource.tagName === "string" &&
//               videoSource.tagName === "SOURCE"
//             ) {
//               videoSource.src = videoSource.dataset.src;
//             }
//           }
//
//           video.target.load();
//           video.target.closest(".video-wrapper").classList.add("loaded");
//           lazyVideoObserver.unobserve(video.target);
//         }
//       });
//     });
//
//     lazyVideos.forEach(function(lazyVideo) {
//       lazyVideoObserver.observe(lazyVideo);
//     });
//   }

  // Counts up the percentages
  //   function countUp() {
  //     $(".stat-wrapper .stat").each(function() {
  //       var $this = $(this);
  //       var countTo = $this.attr("data-count");

  //       $({ countNum: $this.text() }).animate(
  //         { countNum: countTo },
  //         {
  //           duration: 1000,
  //           easing: "linear",
  //           step: function() {
  //             $this.text(Math.floor(this.countNum));
  //           },
  //           complete: function() {
  //             $this.text(this.countNum);
  //           }
  //         }
  //       );
  //     });
  //   }
  //   // Initializes the starting of the countUp function
  //   $(".stat-wrapper").appear();
  //   $(".stat-wrapper").on("appear", function() {
  //     countUp();
  //   });

  // var showMenus = (function() {
  //   var executed = false;
  //   return function() {
  //     if (!executed) {
  //       // executed = true;
  //       $("#menu-top-menu li").each(function(index) {
  //         $(this)
  //           .delay(200 * index)
  //           .queue(function() {
  //             $(this)
  //               .addClass("shown")
  //               .dequeue();
  //           });
  //       });
  //     }
  //   };
  // })();

  $(".off-canvas").on("opened.zf.offcanvas", function(e) {
    $(".hamburger").toggleClass("is-active");
    showMenus();
  });
  $(".off-canvas").on("closed.zf.offcanvas", function(e) {
    $(".hamburger").toggleClass("is-active");
    $("#menu-top-menu li").each(function() {
      $(this).removeClass("shown");
    });
  });

  //Scroll Progress
//   var $prog2 = $(".progress-indicator-2");
//   function updateProgress(perc) {
//     $prog2.css({ width: perc * 100 + "%" });
//   }
//
//   (function() {
//     var $w = $(window);
//     var $circ = $(".animated-circle");
//     var $progCount = $(".progress-count");
//     var $prog = $(".progress-indicator");
//     var $prog2 = $(".progress-indicator-2");
//     var h = $("#main-content article.post").outerHeight(true);
//     // var n = $("#top-bar-menu").height();
//     // var a = $("#wpadminbar").height();
//     var hero = $(".hero").outerHeight(true);
//     // console.log('#top-bar-menu', n)
//     // console.log("#main-content article.post", h);
//     // console.log(".hero", hero);
//     var sHeight = h + hero;
//     $w.on("scroll", function() {
//       // console.log('scroll top', $w.scrollTop())
//       // console.log('article height', sHeight)
//       var perc = Math.max(0, Math.min(1, $w.scrollTop() / sHeight));
//       updateProgress(perc);
//       if ($w.scrollTop() < 100 || perc >= 1) {
//         $prog2.css("opacity", 0);
//         $prog.css("opacity", 0);
//       } else {
//         $prog2.css("opacity", 1);
//         $prog.css("opacity", 1);
//       }
//     });
//
//     function updateProgress(perc) {
//       var circle_offset = 126 * perc;
//       $circ.css({
//         "stroke-dashoffset": 126 - circle_offset
//       });
//       $progCount.html(Math.round(perc * 100) + "%");
//
//       $prog2.css({ width: perc * 100 + "%" });
//     }
//   })();

  //Slugify function
  function slugify(string) {
    const a = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;";
    const b = "aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------";
    const p = new RegExp(a.split("").join("|"), "g");
    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with ‘and’
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  }
});
